import React from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Flex,
    useMultiStyleConfig,
    Button,
    Box,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CloseIcon, NumberIcon} from '../../../../components/icons'
import {FormattedMessage} from 'react-intl'

const ReturnOrderModal = ({isOpen, onClose, returnTracking = null}) => {
    const styles = useMultiStyleConfig('Orders')
    const steps = [1, 2, 3, 4, 5]
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent {...styles.returnModalContainer}>
                <ModalHeader width={'100%'} padding={0}>
                    <Flex {...styles.returnModalHeader}>
                        <Flex>
                            <Text {...styles.returnModalTitle}>
                                <FormattedMessage
                                    id="return_order_modal_title"
                                    defaultMessage="Order return: how it works"
                                />
                            </Text>
                        </Flex>
                        <CloseIcon data-testid="close-button" onClick={onClose} />
                    </Flex>
                </ModalHeader>
                <ModalBody data-testid="modal-body" padding={0}>
                    {returnTracking ? (
                        <Button
                            as="a"
                            href={returnTracking}
                            target="_blank"
                            variant={'text-button'}
                            isExternal
                            {...styles.returnModalButton}
                        >
                            <FormattedMessage
                                id="return_order_modal_description"
                                defaultMessage="View tracking code"
                            />
                        </Button>
                    ) : (
                        <Box {...styles.returnModalDummyBox} />
                    )}
                    {steps.map((step, index) => (
                        <Flex key={index} alignItems="center" {...styles.returnModalStepsContainer}>
                            <NumberIcon number={index + 1} {...styles.returnModalStepIcon} />
                            <Text {...styles.returnModalStep}>
                                {/* Predefined static FormattedMessage components for each step */}
                                {index === 0 && (
                                    <FormattedMessage
                                        id="return_order_modal_step_1"
                                        defaultMessage="Buy product"
                                    />
                                )}
                                {index === 1 && (
                                    <FormattedMessage
                                        id="return_order_modal_step_2"
                                        defaultMessage="Buy product"
                                    />
                                )}
                                {index === 2 && (
                                    <FormattedMessage
                                        id="return_order_modal_step_3"
                                        defaultMessage="Buy product"
                                    />
                                )}
                                {index === 3 && (
                                    <FormattedMessage
                                        id="return_order_modal_step_4"
                                        defaultMessage="Buy product"
                                    />
                                )}
                                {index === 4 && (
                                    <FormattedMessage
                                        id="return_order_modal_step_5"
                                        defaultMessage="Buy product"
                                    />
                                )}
                            </Text>
                        </Flex>
                    ))}
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

ReturnOrderModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    returnTracking: PropTypes.string,
}

export default ReturnOrderModal
